import { useQuery } from 'react-query';
import { getCurrentUser } from '../api/auth';

export const CURRENT_USER_QUERY_KEY = 'currentUser';

export const useCurrentUser = () => {
  const query = useQuery(CURRENT_USER_QUERY_KEY, getCurrentUser, {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const user = query.data ?? null;
  const role = typeof user?.role === 'string' ? user.role.trim() : '';

  // Rol gelmediyse (istek başarısız ya da eski backend) kullanıcıyı
  // kilitlemiyoruz; asıl yetki kontrolü backend'de, buradaki sadece görsel.
  const isRoleKnown = role.length > 0;
  const isAdmin = role.toLowerCase() === 'admin';

  const displayName =
    user?.fullName?.trim() || user?.userName || user?.email || '';

  return {
    ...query,
    user,
    role,
    isRoleKnown,
    isAdmin,
    canManageUsers: !isRoleKnown || isAdmin,
    displayName,
  };
};

export default useCurrentUser;
